<div
  role="button"
  tabindex="0"
  (click)="onClickCard()"
  (keydown.enter)="onClickCard()"
  (keydown.space)="onClickCard()"
  [className]="(isInline ? '' : ' card-hover ') + ' p-4 w-full text-left cursor-pointer group'"
>
  <div class="flex items-start gap-4 relative">
    <!-- Left: content -->
    <div class="flex-1 min-w-0 pr-10">
      <!-- Title and State -->
      <div class="flex items-center gap-3 mb-1">
        <h3 class="card-title truncate group-hover:text-secondary transition-colors">
          {{ project.title }}
        </h3>
        <span [class]="getStateClass()">{{ formatState(project.state) }}</span>
      </div>

      <!-- Group, Research Leader, and Role -->
      <div
        class="text-xs text-gray-600 font-medium tracking-wide flex items-center gap-4 flex-wrap"
      >
        <div class="flex items-center gap-1">
          <span class="opacity-75">Group:</span>
          <span class="text-blue-600 font-semibold">{{ project.groupName }}</span>
        </div>

        <span class="text-gray-400">•</span>

        <div class="flex items-center gap-1">
          <span class="opacity-75">PI:</span>
          <span class="font-medium">{{ project.piName }}</span>
        </div>

        @if (userRole && userRole.role !== 'NONE') {
          <span class="text-gray-400">•</span>
          <div class="flex items-center gap-1">
            <span class="opacity-75">Role:</span>
            @if (userRole?.role === 'PI') {
              <span
                class="inline-flex items-center gap-0.5 rounded-full bg-yellow-100 px-2 py-0.5 text-xs font-bold text-yellow-800 border border-yellow-300 ml-1"
              >
                <span>⭐</span> PI
              </span>
            } @else {
              <span [class]="getRoleClass()">{{ userRole.role }}</span>
            }
          </div>
        }

        @if (paperCount > 0) {
          <span class="text-gray-400">•</span>
          <div class="flex items-center gap-1">
            <span class="opacity-75">Papers:</span>
            <span class="font-semibold">{{ paperCount }}</span>
          </div>
        }
      </div>

      <!-- Description -->
      <p class="text-sm text-gray-600 line-clamp-2 mt-0.5">
        {{ project.description || 'No description provided.' }}
      </p>

      <!--   temporary(?) removal, doesnt seem necessary atm, just click inside the project!   -->
      <!--      @if (canLeaveProject()) {-->
      <!--        <div class="mt-3">-->
      <!--          <button-->
      <!--            type="button"-->
      <!--            class="text-xs px-3 py-1 rounded-md border border-red-300 text-red-600 hover:bg-red-50 transition-colors"-->
      <!--            (click)="onLeaveProject($event)"-->
      <!--          >-->
      <!--            Leave project-->
      <!--          </button>-->
      <!--        </div>-->
      <!--      }-->
    </div>

    <!-- Right: arrow indicator -->
    <div
      class="absolute right-4 top-1/2 -translate-y-1/2 text-2xl font-light flex-shrink-0 text-secondary opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none"
    >
      →
    </div>
  </div>
</div>
